import { apiClient, emitInvalidDevice } from "./CommonApi";
import { APIURL, getHeaders } from "./config";

export const taskInit = async () => {
  const headers = await getHeaders();

  const body = {
    con: JSON.stringify({ id: "", mode: "gettoken" }),
    p: "",
    f: "init api for initialization",
  };

  try {
    const { data } = await apiClient.post(APIURL, body, { headers });

    const initRow = data?.Data?.rd?.[0];
    if (initRow?.stat_code === 1001 || initRow?.stat_msg === "Invalid Device!!") {
      emitInvalidDevice(initRow?.stat_msg || 'Invalid Device!!');
      return null;
    }

    if (data?.Data?.rd?.[0]?.stat != 0) {
      sessionStorage.setItem("taskInit", JSON.stringify(data.Data.rd[0]));
      sessionStorage.setItem("pageAccess", JSON.stringify(data.Data.rd1));
    } else {
      console.warn("No `rd` data found in response:", data?.Data?.rd?.[0]?.stat_msg);
    }

    return data;
  } catch (error) {
    console.error("Error in taskInit:", error.message || error);
    return null;
  }
};
